import { render, staticRenderFns } from "./NonImmigrantVisaHomeTemplate.vue?vue&type=template&id=9cc63a9a&scoped=true"
import script from "./NonImmigrantVisaHomeTemplate.vue?vue&type=script&lang=js"
export * from "./NonImmigrantVisaHomeTemplate.vue?vue&type=script&lang=js"
import style0 from "./NonImmigrantVisaHomeTemplate.vue?vue&type=style&index=0&id=9cc63a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc63a9a",
  null
  
)

export default component.exports